import React from 'react';
import Section from '../common/Section';
import Button from '../ui/Button';
import { ShieldCheck, BrainCircuit, Lock } from 'lucide-react';

/**
 * Final call to action panel.
 */
const FinalCTASection = () => {
  return (
    <Section id="get-started" background="white" padding="md" panel={false} className="pt-2" style={{ backgroundColor: 'var(--cream-canvas)' }}>
      <div className="max-w-4xl mx-auto">
        <div
          className="rounded-3xl p-8 sm:p-10"
          style={{ backgroundColor: 'var(--brand-green-deep)', boxShadow: '0 20px 40px rgba(20, 48, 36, 0.24)' }}
        >
          <h2 className="text-2xl sm:text-3xl font-extrabold text-white text-center">
            Start where you are
          </h2>

          <p className="text-white/80 text-center mt-3 max-w-2xl mx-auto">
            You don't need to be ready. Day 1 meets you where you are today.
          </p>

          <div className="mt-8 flex justify-center">
            <Button
              size="lg"
              onClick={() => (window.location.href = '/register')}
              className="!rounded-xl !py-3 !px-8 text-base font-extrabold transition-all duration-300 hover:shadow-2xl hover:-translate-y-1"
              style={{
                backgroundColor: 'var(--gold-accent)',
                color: 'var(--gold-accent-text)',
              }}
            >
              Start day 1
            </Button>
          </div>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-3 text-xs sm:text-sm text-white/85">
            <span className="inline-flex items-center gap-1.5"><ShieldCheck size={16} /> HIPAA compliant</span>
            <span className="inline-flex items-center gap-1.5"><BrainCircuit size={16} /> Evidence based</span>
            <span className="inline-flex items-center gap-1.5"><Lock size={16} /> AES-256 encrypted</span>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default FinalCTASection;
